const state = {};

export const saveState = (component, object) => {
  state[component] = { ...state[component], ...object };
};

export const getState = (component, key) => {
  return key ? state[component] && state[component][key] : state[component];
};

export const clearState = (component) => {
  state[component] = {};
};
